export class SchedulingDTO {
    DeviceId: string;
    ModuleId: string;
    Type: string;
    StartMacroName: string;
    EndMacroName: string;
    ExpirationDate: Date;
    Schedules: ScheduleDTO[];
    Enabled: boolean;
    StartMacroId: string;
    EndMacroId: string;
  }

export class ScheduleDTO {
    From: string;
    To: string;
    Mon: boolean;
    Tue: boolean;
    Wed: boolean;
    Thu: boolean;
    Fri: boolean;
    Sat: boolean;
    Sun: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/DTO/SchedulingDTO.ts